interface Props {
  contentCategoryKeys: string[];
  taxonomies: Record<string, string>;
}

const resolveElasticContentCategoryValues = ({
  contentCategoryKeys = [],
  taxonomies = {},
}: Props): string[] => {
  if (!contentCategoryKeys.length) return [];
  if (!Object.keys(taxonomies).length) return [];

  return contentCategoryKeys
    ?.filter((category) => !!taxonomies?.[category])
    ?.map((category) => taxonomies?.[category]);
};

export default resolveElasticContentCategoryValues;
